/*
 asynchronous_result_after_single_call
 */

import dataFlow from '../../common/lib/dataflow.js';
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';

const register = dataFlow.register;

function registerActions() {
	function asynchronousResultAfterSingleCall(payload) {
		let accHistRef;
		let paymentFetchResultFlow;
		if (payload.type === constants.SUBMIT_PAYMENT) {
			/* the handling of the submit and result is filtered by sendHandlerType */
			if (payload && payload.sendHandlerType === constants.ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL) {
				accHistRef = payload.accHistRef;
				paymentFetchResultFlow = payload.paymentFetchResultFlow;
				actions.asynchronousResultAfterSingleCall({
					fetch_type: constants.FETCH_TYPE_ASYNCH,
					accHistRef,
					paymentFetchResultFlow
				});
			}
		}
	}
	register(asynchronousResultAfterSingleCall);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/asynchronous-result-after-single-call.js